import { SelectUnitRow } from './types'

export const SELECT_UNIT_ROW_0 = [
  {
    unitNumber: '1',
    size: '12x35',
    isCovered: true,
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '1lKlnXe2jX',
  },
  {
    unitNumber: '2',
    size: '12x35',
    isCovered: true,
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '2NA1is6517',
  },
  {
    unitNumber: '3',
    size: '12x35',
    isCovered: true,
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '3MV6Up-lvP',
  },
  {
    unitNumber: '4',
    size: '12x35',
    isCovered: true,
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'Gci7k59Lsp',
  },
  {
    unitNumber: '5',
    size: '12x35',
    isCovered: true,
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'J2kDXDtzIJ',
  },
  {
    unitNumber: '6',
    size: '12x35',
    isCovered: true,
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'Zc2jJWQyto',
  },
  {
    unitNumber: '7',
    size: '12x35',
    isCovered: true,
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '_BIGEsyVF6',
  },
  {
    unitNumber: '8',
    size: '12x35',
    isCovered: true,
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'blYtUDy3YQ',
  },
  {
    unitNumber: '9',
    size: '12x35',
    isCovered: true,
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'cgSZrub-ia',
  },
  {
    unitNumber: '10',
    size: '12x35',
    isCovered: true,
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'dm19iyNX8g',
  },
  {
    unitNumber: '11',
    size: '12x35',
    isCovered: true,
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'nsAtQ6lpOF',
  },
  {
    unitNumber: '12',
    size: '12x35',
    isCovered: true,
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'rFFFULpcov',
  },
  {
    unitNumber: '13',
    size: '12x35',
    isCovered: true,
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'uIXuQbPDTw',
  },
  {
    unitNumber: '14',
    size: '12x35',
    isCovered: true,
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'y_MSlCgAAy',
  },
] as SelectUnitRow[]

export const SELECT_UNIT_ROW_1 = [
  {
    unitNumber: '117',
    size: '10x15',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '7emaZFu5v2',
  },
  {
    unitNumber: '118',
    size: '10x15',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'C586ApQWul',
  },
  {
    unitNumber: '119',
    size: '10x15',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'DcpiYXKwgO',
  },
  {
    unitNumber: '120',
    size: '10x15',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'MCmzCHoior',
  },
  {
    unitNumber: '121',
    size: '10x15',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'QxxSYqBaLw',
  },
  {
    unitNumber: '122',
    size: '10x15',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'SLCd6DvTnO',
  },
  {
    unitNumber: '123',
    size: '10x15',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'aadrZz0DDl',
  },
  {
    unitNumber: '124',
    size: '10x15',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'd_WUbVstay',
  },
  {
    unitNumber: '125',
    size: '10x15',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'i1gt27q415',
  },
  {
    unitNumber: '126',
    size: '10x15',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'myrgf-5VA4',
  },
  {
    unitNumber: '127',
    size: '10x15',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'o1ILVMeBjL',
  },
  {
    unitNumber: '128',
    size: '10x15',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'upiwvfybnq',
  },
  {
    unitNumber: '129',
    size: '10x15',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'xY_UsnUOdK',
  },
  {
    unitNumber: '130',
    size: '10x15',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'zk16Psla68',
  },
] as SelectUnitRow[]

export const SELECT_UNIT_ROW_2 = [
  {
    unitNumber: '131',
    size: '5x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '9OZquWBWT',
  },
  {
    unitNumber: '132',
    size: '5x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'R0MoDPfjdm',
  },
  {
    unitNumber: '133',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '-tK6Qm8-D',
  },
  {
    unitNumber: '134',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '1bdhNYDi-0',
  },
  {
    unitNumber: '135',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '1mNmWyR76pD',
  },
  {
    unitNumber: '136',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '2EBoqULpcOb',
  },
  {
    unitNumber: '137',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '79xNlGaTQDP',
  },
  {
    unitNumber: '138',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '7FOvjugfUtE',
  },
  {
    unitNumber: '139',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '8HT9uQ0iaF',
  },
  {
    unitNumber: '140',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'CzwGBZXZpw',
  },
  {
    unitNumber: '141',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'F0ZB3bSacPf',
  },
  {
    unitNumber: '142',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'GBRe45KY-f3',
  },
  {
    unitNumber: '143',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'JfiCIYpU48',
  },
  {
    unitNumber: '144',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'NTuswWF4gXf',
  },
  {
    unitNumber: '145',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'O1_C_Gb_eX',
  },
] as SelectUnitRow[]

export const SELECT_UNIT_ROW_3 = [
  {
    unitNumber: '146',
    size: '5x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'kaObtelztk',
  },
  {
    unitNumber: '147',
    size: '5x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'lhjGjf3iGg',
  },
  {
    unitNumber: '148',
    size: '5x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'nuI-dn6N7q',
  },
  {
    unitNumber: '149',
    size: '5x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'w9nRxrn7PW',
  },
  {
    unitNumber: '150',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'QS8VVvDFFb',
  },
  {
    unitNumber: '151',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'X-FpB-yi0Z',
  },
  {
    unitNumber: '152',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '_WctKpxv7H7',
  },
  {
    unitNumber: '153',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '_xHqh7Dy83',
  },
  {
    unitNumber: '154',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'czDwH4msGM',
  },
  {
    unitNumber: '155',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'g5aZWnhe6j',
  },
  {
    unitNumber: '156',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'hb72mlwq_Sy',
  },
  {
    unitNumber: '157',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'jdf939xeOi',
  },
  {
    unitNumber: '158',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'mEXFZC0M_R',
  },
  {
    unitNumber: '159',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'o0zDuT2blf',
  },
  {
    unitNumber: '160',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'omv2MNTuqF',
  },
  {
    unitNumber: '161',
    size: '10x10',
    isClimate: true,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'pHj9lp7ZeK',
  },
] as SelectUnitRow[]

export const SELECT_UNIT_ROW_4 = [
  {
    unitNumber: '101',
    size: '5x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '594EOGY9lS',
  },
  {
    unitNumber: '102',
    size: '5x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'jDhBaar8P0',
  },
  {
    unitNumber: '103',
    size: '5x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'jzNrKqq1Qr',
  },
  {
    unitNumber: '104',
    size: '5x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'rplR3knEWY',
  },
  {
    unitNumber: '105',
    size: '10x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: '3QceCWQkZM',
  },
  {
    unitNumber: '106',
    size: '10x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'OHD2bZp9wl',
  },
  {
    unitNumber: '107',
    size: '10x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'QDGUwyF1rE',
  },
  {
    unitNumber: '108',
    size: '10x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'QVZr1F8JZu',
  },
  {
    unitNumber: '109',
    size: '10x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'SWZ2jMgBCB',
  },
  {
    unitNumber: '110',
    size: '10x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'WOAGZ-TbO1',
  },
  {
    unitNumber: '111',
    size: '10x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'WfrdxY8xIA',
  },
  {
    unitNumber: '112',
    size: '10x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'aRtl812Cnt',
  },
  {
    unitNumber: '113',
    size: '10x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'f0BRRrT7ll',
  },
  {
    unitNumber: '114',
    size: '10x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'kUEi4RUbdi',
  },
  {
    unitNumber: '115',
    size: '10x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'tEMLM-_NXr',
  },
  {
    unitNumber: '116',
    size: '10x10',
    isClimate: false,
    isSelectable: false,
    isUnavailable: false,
    isSelected: false,
    id: 'zhLhrn61oj',
  },
] as SelectUnitRow[]
